import { useEffect, useRef, useState } from "react";
import CVTemplate1 from "../components/consulter-cv-new-temp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../style/style-cv-1.css";
import { faCloudDownload, faEdit } from "@fortawesome/free-solid-svg-icons";
import ChoisireTemplate from "../components/choisire-template";
import CVTemplate2 from "../components/consulter-cv-annc-template";
import Cookies from "js-cookie";
import axios from "../axios/axios";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export default function ConsulterCv() {
  const navigate = useNavigate();
  const pdfRef = useRef();
  const [imagesLoaded, setImagesLoaded] = useState(false);

  const [choisireTemplate, setChoisireTemplate] = useState(0);
  const token = Cookies.get("auth_token");
  const [user, setUser] = useState({});
  const [cv, setCv] = useState({});
  const [formations, setFormations] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [langues, setLangues] = useState([]);
  const [competences, setCompetences] = useState([]);
  const [piecejointes, setPiecejointes] = useState([]);
  const [chargement, setChargement] = useState(false);

  useEffect(() => {
    getCv();
  }, []);

  const getCv = () => {
    setChargement(true);
    axios
      .get("/consultCv", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.msg == "cv-404") {
          navigate(`${process.env.PUBLIC_URL}/completer-voter-cv`);
        } else {
          setUser(response.data.user);
          setCv(response.data.cv);
          setFormations(response.data.formations);
          setExperiences(response.data.experiences);
          setLangues(response.data.langues);
          setCompetences(response.data.skills);
          setPiecejointes(response.data.ps);
        }
        setChargement(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const changerTemplate = (num) => {
    setChoisireTemplate(num);
  };

  const suprimerExperience = (id) => {
    Swal.fire({
      title: "Êtes-vous sûr de supprimer cette experience ?",
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      cancelButtonText: "Annuler",
      customClass: {
        title: "custom-title-class",
      },
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios
          .get(`/suprimerExperience/${id}`, {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            getCv();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const suprimerFormation = (id) => {
    Swal.fire({
      title: "Êtes-vous sûr de supprimer cette formation ?",
      // showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      cancelButtonText: "Annuler",
      customClass: {
        title: "custom-title-class",
      },
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios
          .get(`/suprimerFormation/${id}`, {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            getCv();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const suprimerLangue = (id) => {
    Swal.fire({
      title: "Êtes-vous sûr de supprimer cette Langue ?",
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      cancelButtonText: "Annuler",
      customClass: {
        title: "custom-title-class",
      },
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios
          .get(`/suprimerLangue/${id}`, {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            getCv();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const suprimerCompetence = (id) => {
    Swal.fire({
      title: "Êtes-vous sûr de supprimer cette Compétence ?",
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      cancelButtonText: "Annuler",
      customClass: {
        title: "custom-title-class",
      },
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        axios
          .get(`/suprimerCompetence/${id}`, {
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            getCv();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const editeCV = (e) => {
    Cookies.remove("addPJ");
    navigate(`${process.env.PUBLIC_URL}/modifier-cv/${cv.id}`);
  };

  return chargement == true ? (
    <div className="container card text-center mt-5">
      <h4>Chargement .... </h4>
    </div>
  ) : (
    <ProtectedRoute>
      <ChoisireTemplate changerTemplate={changerTemplate} />

      <div className="container-fluid overcover">
        <div className="container profile-box">
          <div className="rt-div">
            <div className="rit-cover">
              <div className="about">
                <div className="btn-ro row ">
                  <ul className="btn-link" style={{ listStyleType: "none" }}>
                    <li style={{ borderBlockColor: "#00ab9f" }}>
                      <a
                        style={{ color: "#00ab9f", cursor: "pointer" }}
                        onClick={editeCV}
                      >
                        <FontAwesomeIcon icon={faEdit} /> Modifier
                      </a>
                    </li>

                    <li>
                      <Link
                        style={{ color: "#888" }}
                        to={
                          choisireTemplate == 1
                            ? process.env.NODE_ENV === "production"
                              ? process.env.REACT_APP_API_URL_PROD +
                                `imprimerCV/${cv.id}`
                              : process.env.REACT_APP_API_URL_LOCAL +
                                `/imprimerCV/${cv.id}`
                            : // : process.env.REACT_APP_API_URL_LOCAL_FOR_DOMPDF + `/imprimer_CV_template2/${cv.id}`
                            process.env.NODE_ENV === "production"
                            ? process.env.REACT_APP_API_URL_PROD +
                              `imprimer_CV_template2/${cv.id}`
                            : process.env.REACT_APP_API_URL_LOCAL +
                              `/imprimer_CV_template2/${cv.id}`
                          // : process.env.REACT_APP_API_URL_LOCAL_FOR_DOMPDF + `/imprimer_CV_template2/${cv.id}`
                        }
                      >
                        <FontAwesomeIcon icon={faCloudDownload} /> Télécharger
                        votre CV en pdf
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div id="pdf-content" style={{ padding: "10px" }}>
              {choisireTemplate == 0 ? (
                <CVTemplate1
                  cv={cv}
                  formations={formations}
                  experiences={experiences}
                  competences={competences}
                  langues={langues}
                  piecejointes={piecejointes}
                  suprimerExperience={suprimerExperience}
                  suprimerFormation={suprimerFormation}
                  suprimerLangue={suprimerLangue}
                  suprimerCompetence={suprimerCompetence}
                />
              ) : (
                <CVTemplate2
                  cv={cv}
                  formations={formations}
                  experiences={experiences}
                  competences={competences}
                  langues={langues}
                  piecejointes={piecejointes}
                  suprimerExperience={suprimerExperience}
                  suprimerFormation={suprimerFormation}
                  suprimerLangue={suprimerLangue}
                  suprimerCompetence={suprimerCompetence}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
}
